<template>
  <mk-table
    ref="multipleTable"
    style="width: 100%;"
    height="100%"
    :data="tableData"
    @selection-change="handleSelectionChange"
  >
    <mk-table-column
      type="selection"
      width="55"
    >
    </mk-table-column>
    <mk-table-column
      v-for="(item,index) in formData.titleList"
      :key="index"
      :prop="item.id"
      :label="item.name"
      min-width="160"
    >
    </mk-table-column>
  </mk-table>
</template>
<script>
export default {
  name: 'TableList',
  props: {
    needCheckbox: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {
          titleList: [],
          contentList: []
        }
      },
      hideList: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    cancelAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkAll: false
    }
  },
  computed: {
    tableData () {
      let arr = []
      if (
        this.formData &&
        this.formData.contentList &&
        this.formData.contentList.length > 0
      ) {
        for (let i = 0; i < this.formData.contentList.length; i++) {
          let obj = {}
          arr.push(obj)
          if (this.formData.contentList[i].length > 0) {
            for (let j = 0; j < this.formData.contentList[i].length; j++) {
              if (
                this.formData.contentList[i][j] !== undefined &&
                this.formData.contentList[i][j].id !== 'nickName' &&
                this.formData.contentList[i][j].id !== undefined &&
                this.formData.contentList[i][j].id !== 'avatarURL' &&
                this.formData.contentList[i][j].id !== 'upload'
              ) {
                obj.deleteId = this.formData.contentList[i][j].id
              }
              if (this.formData.contentList[i][j]) {
                let key = this.formData.contentList[i][j].key
                let value = this.formData.contentList[i][j].value
                obj[key] = value
              }
            }
          }
        }
      }
      return arr
    }
  },
  watch: {
    cancelAll (val) {
      if (val) {
        this.toggleSelection()
      }
    }
  },
  methods: {
    toggleSelection (rows) {
      // this.$refs.multipleTable.$children[0].clearSelection()
      this.$refs.multipleTable.clearSelection()
    },
    handleSelectionChange (e) {
      let arr = []
      if (e.length > 0) {
        let i = 0
        let len = e.length
        for (i; i < len; i++) {
          arr.push(e[i].deleteId)
        }
      }
      this.$emit('change', arr)
    },
    select (index) {
      if (this.formData.contentList && this.formData.contentList.length > 0) {
        let i = 0
        let len = this.formData.contentList.length
        let ids = []
        for (i; i < len; i++) {
          let j = 0
          if (
            this.formData.contentList[i] &&
            this.formData.contentList[i].length > 0
          ) {
            let conLen = this.formData.contentList[i].length
            if (
              this.formData.contentList[i] &&
              this.formData.contentList[i].length > 0 &&
              this.formData.contentList[i][0].checked
            ) {
              ids.push(this.formData.contentList[i][0].id)
            }
          }
        }
        this.$emit('change', {
          checked: ids
        })
      }
    },
    selectAll () {
      this.checkAll = this.formData.titleList[0].checked
      if (this.formData.contentList && this.formData.contentList.length > 0) {
        let i = 0
        let len = this.formData.contentList.length
        let ids = []
        for (i; i < len; i++) {
          let j = 0
          if (
            this.formData.contentList[i] &&
            this.formData.contentList[i].length > 0
          ) {
            let conLen = this.formData.contentList[i].length
            ids.push(this.formData.contentList[i][j]._id)
            for (j; j < conLen; j++) {
              if (this.checkAll) {
                this.formData.contentList[i][j].checked = true
              } else {
                this.formData.contentList[i][j].checked = false
              }
            }
          }
        }
        if (this.checkAll) {
          this.$emit('change', {
            checked: ids
          })
        } else {
          this.$emit('change', {
            checked: []
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.avatarURL {
  display: block;
  width: 32px;
}

.table-list {
  .title,
  .content {
    ul {
      display: flex;
    }

    li {
      flex: 1;
      height: 40px;
      background: rgba(250, 250, 250, 1);
      box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;

      .select {
        margin-right: 10px;
      }
    }
  }

  .title {
    font-weight: 500;

    li {
      font-size: 14px;
      color: rgba(89, 89, 89, 1);
      line-height: 1;
    }
  }

  .content {
    li {
      font-size: 13px;
      color: rgba(89, 89, 89, 1);
      line-height: 40px;
    }
  }
}
</style>
